import React, { useEffect, useState } from "react";
import { SectionContainer } from "../SectionContainer";
import { SubmenuControls } from "../SubmenuControls";

export const NaturalRisks = ({data, addressInfos, outlineCity, scenario, updateAddress, openMedia, selectedItem, onSelectItem}) => {
    const changeItem = (itemId, scenario) => {
        onSelectItem('risques-naturels', itemId, scenario ? scenario : null);
    }

    return (
        <main className="main-container" aria-label="Zone de contenu principal">
            <div className="content">
                <SubmenuControls selectedItem={selectedItem} data={data} onSelectedItem={(itemId) => itemId != 'crues_a_niort' ? changeItem(itemId): changeItem(itemId, 125)}/>
                <div className="subcontent">
                    <SectionContainer
                        title={selectedItem.label}
                        openMedia={openMedia}
                        selectedItem={selectedItem}
                        addressInfos={addressInfos}
                        outlineCity={outlineCity}
                        scenario={scenario}
                        updateAddress={updateAddress}
                        onSelectScenario={changeItem}
                    />
                </div>
            </div>
        </main>
    )
}